/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Toast_Storage_UpgradedInputs */



/**
* | output |
* | --- |
* | "Storage upgraded." |
*
* @param {Sub_Addons_Toast_Storage_UpgradedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_toast_storage_upgraded = /** @type {((inputs?: Sub_Addons_Toast_Storage_UpgradedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Toast_Storage_UpgradedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Speicher aktualisiert.")
	return /** @type {LocalizedString} */ ("Storage upgraded.")
});